import { render, staticRenderFns } from "./AdminFormServiceSidebar.vue?vue&type=template&id=45e0750a&"
import script from "./AdminFormServiceSidebar.vue?vue&type=script&lang=ts&"
export * from "./AdminFormServiceSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./AdminFormServiceSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports